import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import CourseOverview from './CourseOverview'
import CourseList from './CourseList'

const CoursesIndex = () => {
    return (
        <>
            <Bredcrum
                heading={'Our Courses'}
                path={[
                    { name: 'Courses', path: 'courses' },
                ]}
            />

            <CourseOverview />
            <CourseList />
        </>
    )
}

export default CoursesIndex